/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Fresh_Tame_Emu_RaceInputs */

const en_fresh_tame_emu_race = /** @type {(inputs: Fresh_Tame_Emu_RaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Source: ${i?.source}`)
};

const de_fresh_tame_emu_race = /** @type {(inputs: Fresh_Tame_Emu_RaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quelle: ${i?.source}`)
};

/**
* | output |
* | --- |
* | "Source: {source}" |
*
* @param {Fresh_Tame_Emu_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_tame_emu_race = /** @type {((inputs: Fresh_Tame_Emu_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Tame_Emu_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_tame_emu_race(inputs)
	return de_fresh_tame_emu_race(inputs)
});